import React from 'react';
import { CustomTextField } from '../../../../common/CustomTextField';

/**
 * Minimal wrapper over a text field to build an attachment meta-information component.
 *
 * @param id used for the id, testId and name of the NumberField
 * @param label label of the numerical field
 * @param form hosting form
 * @param readOnly
 * @param className
 * @param InputProps input props to forward to the internal TextField
 * @param rows number of rows (optional, will default to 1)
 * @param validations react-hook-form format validations
 *  E.g.:
 *    const documentTypeValidation = fieldName => ({
 *     validate: {
 *       all: all(),
 *       required: required(fieldName),
 *       string: text(1, 128),
 *     },
 *   });
 * @returns {JSX.Element}
 * @constructor
 */
const AttachmentMetaText = ({ id, label, form, readOnly, className, InputProps, rows, validations }) => {
  const { errors, register, clearErrors } = form;

  return (
    <CustomTextField
      className={className}
      testId={id}
      name={id}
      id={id}
      label={label}
      readOnly={readOnly}
      errors={errors}
      inputRef={register(validations())}
      register={register}
      InputProps={InputProps}
      multiline={!!rows && rows > 1}
      showTooltip={true}
      rows={rows}
      onChange={() => {
        // Clear any existing error for the field after making an update
        // Field validation shall be triggered after clicking Upload File only
        if (errors?.[id]) clearErrors(id);
      }}
    />
  );
};

export default AttachmentMetaText;
